'use client';

import { Pagination, type PaginationProps } from '@cimpress-ui/react';
import type { RowData } from './tanstack.js';
import type { TableEngine } from './types.js';

export interface TablePaginationProps<TData extends RowData> extends Pick<
  PaginationProps,
  | 'UNSAFE_className'
  | 'UNSAFE_style'
  | 'aria-label'
  | 'aria-labelledby'
  | 'aria-describedby'
  | 'aria-details'
  | 'paginatedElementId'
  | 'id'
> {
  /** The data engine created with the `useTableEngine` hook. */
  engine: TableEngine<TData>;
}

export function TablePagination<TData extends RowData>({ engine, ...props }: TablePaginationProps<TData>) {
  return (
    <Pagination
      {...props}
      pageCount={engine.getPageCount()}
      currentPage={engine.getState().pagination.pageIndex + 1}
      onPageChange={(pageNumber) => engine.setPageIndex(pageNumber - 1)}
    />
  );
}

TablePagination.displayName = 'TablePagination';
